/*! IG Homepage DRAFT overlay delay — theme 190828740792 only
 * Owners (2026-09-24 probe):
 *   1) #geoip-banner / .geoip-popup-banner → GeoPro (app embed geo-pro-geolocation)
 *   2) #shopify-pc__banner → Shopify Privacy Banner (storefront-banner.js)
 * SellEasy already OFF in draft settings_data.
 * Early inline (theme.liquid index) arms 4s / intentional interaction; this is backup.
 */
(function () {
  'use strict';
  if (window.__igOverlayDelayInit) return;
  window.__igOverlayDelayInit = true;

  var DELAY_MS = 4000;
  var ready = false;

  function show() {
    if (ready) return;
    ready = true;
    try {
      document.documentElement.classList.add('ig-overlays-ready');
      if (document.body) {
        document.body.classList.add('ig-overlays-ready');
        document.body.style.removeProperty('overflow');
      }
    } catch (e) {}
  }

  function unlock() {
    try {
      if (document.documentElement.classList.contains('ig-overlays-ready')) return;
      /* IG_SPEED_2026_10_19: write only when needed (was rewritten on every DOM mutation = style recalc) */
      var b = document.body; if (b && !(b.style.getPropertyValue('overflow') === 'auto' && b.style.getPropertyPriority('overflow') === 'important')) b.style.setProperty('overflow', 'auto', 'important');
    } catch (e) {}
  }

  if (document.documentElement.classList.contains('ig-overlays-ready')) {
    ready = true;
    return;
  }

  setTimeout(show, DELAY_MS);
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, show, { once: true, passive: true, capture: true });
  });
  window.addEventListener(
    'scroll',
    function onScroll() {
      if ((window.scrollY || window.pageYOffset || 0) > 48) show();
    },
    { passive: true } /* IG_SPEED_2026_10_18: no capture (was catching every carousel scroll -> forced recalc) */
  );

  try {
    var mo = new MutationObserver(function () { unlock(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, DELAY_MS + 2500);
  } catch (e) {}
})();
